// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._34CND{color:#95a1bd;padding:25px 0 0 12px}._7jI04{font-size:14px;font-size:1.4rem}._1qJy_,.bGR1t{font-size:11px;font-size:1.1rem}._1qJy_{color:inherit;text-decoration:underline}._1qJy_:hover{color:#001f5b}", ""]);
// Exports
exports.locals = {
	"currentVersion": "_34CND",
	"currentVersion__versionName": "_7jI04",
	"currentVersion__changeLogUrl": "_1qJy_",
	"currentVersion__releaseDate": "bGR1t"
};
module.exports = exports;
